import { createSelector } from '@reduxjs/toolkit';

import { RootState } from 'types';
import { initialState } from '.';

const selectSlice = (state: RootState) => state.selectedFilters || initialState;

export const selectSelectedFilters = createSelector(
  [selectSlice],
  state => state,
);

export const selectStepSelectedFilters = createSelector(
  [selectSlice, (state, currentStep) => currentStep],
  (selectedFilters, currentStep) => selectedFilters[currentStep] || {},
);

export const selectBasicForm = createSelector(
  [selectSlice, (state, currentStep) => currentStep],
  (selectedFilters, currentStep) =>
    selectedFilters[currentStep].filter.basicForm,
);
